import { CompleteStore } from '../../../../../reducers/reducerTypes';
import { DateTime } from 'luxon';

export const getLastUpdated = (state: CompleteStore): DateTime | null => {
	return state.info.last_updated;
};
